import { SET_ID_TOKEN, RESET_ID_TOKEN, RESET_USER, AUTH_USER_SET, UPDATE_USER_PROFILE, GET_USER_PROFILE } from '../actions'

const INITIAL_STATE = {
    authUser: null,
    idToken: null,
    username: null,
    country: null,
    zipCode: null,
    gardenKnowledge: null,
}

function sessionReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_USER:
            return INITIAL_STATE
        case AUTH_USER_SET:
            return {
                ...state,
                authUser: action.authUser,
            }
        case SET_ID_TOKEN:
            return {
                ...state,
                idToken: {
                    token: action.payload,
                    timestamp: Date.now(),
                },
            }
        case RESET_ID_TOKEN:
            return {
                ...state,
                idToken: null,
            }
        case UPDATE_USER_PROFILE:
        case GET_USER_PROFILE:
            return {
                ...state,
                username: action.payload.body && action.payload.body.username
                    ? action.payload.body.username
                    : state.username,
                country: action.payload.body && action.payload.body.country
                    ? action.payload.body.country
                    : state.country,
                zipCode: action.payload.body && action.payload.body.zipCode
                    ? action.payload.body.zipCode
                    : state.zipCode,
                gardenKnowledge: action.payload.body && action.payload.body.gardenKnowledge
                    ? action.payload.body.gardenKnowledge
                    : state.gardenKnowledge,
            }
        default: return state
    }
}

export default sessionReducer



// WEBPACK FOOTER //
// ./src/reducers/session.js